import { parseElementFromString } from 'anodum';
import injectSiteSocialLinksSettings from './inject-site-social-links-settings';
import injectSiteEmailsSettings from './inject-site-emails-settings';
import constants from '../constants';

const injectSiteSettings = ({
  variable,
  settingValue,
  setting,
  html,
  socialIcons,
  options = {},
}) => {
  let parsedElement = parseElementFromString(html, true);
  let targetElement = parsedElement.querySelector(variable.querySelector);

  if (!targetElement && parsedElement.matches(variable.querySelector)) {
    targetElement = parsedElement;
  }

  if (!targetElement) {
    return parsedElement.outerHTML;
  }

  if (setting === constants.BUSINESS_LOGO) {
    const mediaContainer =
      parsedElement.querySelector('ws-media-container') ||
      targetElement.closest('ws-media-container');

    // Temporary behavior for legacy templates without ws-media-container
    // TODO: Remove after migration to ws-media-container
    if (!mediaContainer) {
      if (typeof settingValue === 'string') {
        if (targetElement.nodeName === 'IMG') {
          targetElement.src = settingValue;
        } else if (targetElement.style.backgroundImage) {
          targetElement.style.backgroundImage = `url('${settingValue}')`;
          targetElement.style.backgroundSize = 'contain';
        } else {
          targetElement.innerHTML = settingValue;
        }
      }

      return parsedElement.outerHTML;
    }

    const img = mediaContainer.querySelector('img');

    if (img && typeof settingValue === 'string') {
      img.src = settingValue;
    }

    if (options.businessLogoAspectRatio) {
      mediaContainer.setAttribute('aspect-ratio', options.businessLogoAspectRatio);
    }

    return parsedElement.outerHTML;
  }

  if (Array.isArray(settingValue)) {
    if (setting === constants.SOCIAL_LINKS) {
      injectSiteSocialLinksSettings({
        settingValue,
        targetElement,
        variable,
        socialIcons,
      });
    } else if (setting === constants.EMAILS) {
      parsedElement = injectSiteEmailsSettings({
        settingValue,
        parsedElement,
      });
    } else {
      targetElement.innerHTML = settingValue.join('<br>');
    }

    return parsedElement.outerHTML;
  }

  if (typeof settingValue === 'string') {
    if (targetElement.nodeName === 'IMG') {
      targetElement.src = settingValue;
    } else if (targetElement.style.backgroundImage) {
      targetElement.style.backgroundImage = `url('${settingValue}')`;
      targetElement.style.backgroundSize = 'contain';
    } else {
      targetElement.innerHTML = settingValue;
    }

    return parsedElement.outerHTML;
  }

  if (setting === constants.BUSINESS_HOURS && settingValue && settingValue.workingSchedule) {
    targetElement.innerHTML = settingValue.workingSchedule.join('<br>');
  }

  return parsedElement.outerHTML;
};

export default injectSiteSettings;
